var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show_msg && _vm.maintenance_msg != '')?_c('div',{staticClass:"mb-5"},[_c('div',{staticClass:"msg-area w-100"},[_vm._v("\n        "+_vm._s(_vm.maintenance_msg)+"\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }